export default "__VITE_ASSET__DycSNT$a__"